import React from 'react';
import PropTypes from 'prop-types';
import { Form } from '@ant-design/compatible';

import { Button, Input } from 'antd';
import { getNumber } from '@xbcb/ui-utils';
// import './VerificationForm.less';

const VerificationForm = ({
  dispatch,
  form,
  flow,
  user,
  delivery,
  remember,
  submit,
  isLoading,
}) => {
  const { getFieldDecorator } = form;
  const { DeliveryMedium, Destination } = delivery;
  const deliveredTo =
    DeliveryMedium === 'TOTP'
      ? 'Enter your authenticator code'
      : `Sent ${DeliveryMedium === 'SMS' ? 'code' : 'email'} to ${Destination}`;

  const handleSubmit = (e) => {
    submit({ e, flow, delivery, user, remember });
  };

  return (
    <Form onSubmit={handleSubmit} className="verification-form">
      <Form.Item>
        <h2>Confirmation code</h2>
      </Form.Item>
      <Form.Item>
        <p>{deliveredTo}</p>
      </Form.Item>
      <Form.Item help={null}>
        {getFieldDecorator('verificationCode', {
          rules: [{ required: true, message: ' ', len: 6 }],
          getValueFromEvent: getNumber(6),
        })(<Input placeholder="XXXXXX" disabled={isLoading} />)}
      </Form.Item>
      <Button
        type="primary"
        htmlType="submit"
        className="login-form-button"
        loading={isLoading}
      >
        Submit
      </Button>
    </Form>
  );
};

VerificationForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  form: PropTypes.any.isRequired,
  history: PropTypes.any.isRequired,
  location: PropTypes.any.isRequired,
  delivery: PropTypes.object.isRequired,
  flow: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
};

export default VerificationForm;
